import React, { useState } from 'react';

// Default Fallback Data
const defaultFAQs = [
    {
        question: "What is BentoBox and how does it work?",
        answer: "BentoBox is a FoodTech platform that connects you with verified home chefs in Gurgaon. We deliver authentic, home-cooked meals right to your doorstep in eco-friendly containers. Simply choose your meal plan, select your preferences, and enjoy fresh, nutritious food daily."
    }
];

const FAQItem = ({ question, answer, isOpen, onClick }) => {
    return (
        <div className="border-b border-gray-200 last:border-b-0">
            <button
                onClick={onClick}
                className="w-full py-5 px-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-200"
            >
                <span className="font-medium text-gray-900 pr-4">{question}</span>
                <span className={`text-orange-500 text-2xl font-light transition-transform duration-300 ${isOpen ? 'rotate-45' : ''}`}>
                    +
                </span>
            </button>
            <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                    }`}
            >
                <div className="px-6 pb-5 text-gray-600 leading-relaxed">
                    {answer}
                </div>
            </div>
        </div>
    );
};

const FAQs = ({ preloadedData, compact = false }) => {
    const [openIndex, setOpenIndex] = useState(0);

    const faqs = preloadedData?.faqs || defaultFAQs;
    const mainHeading = preloadedData?.mainHeading || "Frequently Asked Questions";
    const logoUrl = preloadedData?.logoUrl || '';
    const contactBox = preloadedData?.contactBox || {
        heading: "Do you more questions?",
        content: "Can't find what you're looking for? Our BentoBox customer support team is here to help!",
        button: "Shoot a direct mail",
        img: ""
    };

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? -1 : index);
    };

    return (
        <section id="faqs" className={`${compact ? '!pt-6 md:!pt-8' : '!pt-12 md:!pt-16'} bg-gradient-to-b from-gray-50/50 to-white overflow-hidden`}>
            <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${compact ? 'pt-4 pb-12 md:pt-6 md:pb-16' : 'pt-8 pb-16 md:pt-12 md:pb-24'}`}>
                {/* Header */}
                <div className="text-center mb-12 md:mb-16 relative">
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 inline-block relative">
                        <span className="relative">
                            {mainHeading}
                            {/* Decorative underline */}
                            <svg
                                className="absolute -bottom-2 left-0 w-full"
                                height="8"
                                viewBox="0 0 300 8"
                                fill="none"
                                preserveAspectRatio="none"
                            >
                                <path
                                    d="M0 4C50 0 100 8 150 4C200 0 250 8 300 4"
                                    stroke="#F97316"
                                    strokeWidth="3"
                                    strokeLinecap="round"
                                    fill="none"
                                />
                            </svg>
                        </span>
                    </h1>
                </div>

                {/* Content */}
                <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
                    {/* FAQ Accordion */}
                    <div className="w-full lg:w-2/3">
                        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                            {faqs.map((faq, index) => (
                                <FAQItem
                                    key={faq.id || index}
                                    question={faq.question}
                                    answer={faq.answer}
                                    isOpen={openIndex === index}
                                    onClick={() => toggleFAQ(index)}
                                />
                            ))}
                        </div>
                    </div>

                    {/* More Questions Card */}
                    <div className="w-full lg:w-1/3">
                        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-8 text-center sticky top-24">
                            {/* Logo / Image */}
                            <div className="mb-4 flex justify-center">
                                {/* Prefer specific box img, otherwise fallback to app logo */}
                                {contactBox.img ? (
                                    <img
                                        src={contactBox.img}
                                        alt="Support"
                                        className="w-16 h-16 object-contain"
                                    />
                                ) : logoUrl ? (
                                    <img
                                        src={logoUrl}
                                        alt="BentoBox Logo"
                                        className="w-12 h-12 object-contain"
                                    />
                                ) : (
                                    <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
                                        <span className="text-white font-bold text-lg">B</span>
                                    </div>
                                )}
                            </div>

                            {/* Text */}
                            <h3 className="text-xl font-bold text-gray-900 mb-3">
                                {contactBox.heading}
                            </h3>
                            <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                                {contactBox.content}
                            </p>

                            {/* CTA Button */}
                            <a
                                href="mailto:support@getbentobox.in"
                                className="inline-block w-full bg-orange-500 hover:bg-orange-600 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-300 hover:shadow-lg"
                            >
                                {contactBox.button}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQs;
